import { DocsDocumentPage, DocsIndexPage } from "@/features/docs/DocsPages";

function currentPath(): string {
  return window.location.pathname.replace(/\/+$/, "") || "/";
}

function decoded(value: string): string | null {
  try {
    return decodeURIComponent(value);
  } catch {
    return null;
  }
}

export function App() {
  const path = currentPath();
  if (path === "/" || path === "/docs") return <DocsIndexPage />;
  if (path.startsWith("/docs/sdk/")) {
    const id = decoded(path.slice("/docs/sdk/".length));
    return id ? <DocsDocumentPage id={id} audienceRole="extension-coding" /> : <DocsIndexPage />;
  }
  if (path.startsWith("/docs/")) {
    const id = decoded(path.slice("/docs/".length));
    return id ? <DocsDocumentPage id={id} audienceRole="product-help" /> : <DocsIndexPage />;
  }
  return <DocsDocumentPage id="" />;
}
